module.exports = __webpack_public_path__ + "img/charm_5.e095e3ee.png";